import { render, staticRenderFns } from "./VotingReportingLayer.vue?vue&type=template&id=c10288f4&scoped=true"
import script from "./VotingReportingLayer.vue?vue&type=script&lang=ts"
export * from "./VotingReportingLayer.vue?vue&type=script&lang=ts"
import style0 from "./VotingReportingLayer.vue?vue&type=style&index=0&id=c10288f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c10288f4",
  null
  
)

export default component.exports